import { Box, IconButton, Popover, PopoverBody, PopoverContent, PopoverTrigger, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiBell } from "react-icons/fi";
import { useListMyNotificationsQuery } from "../../../autogen/bff-api";
import { NotificationDropdown } from "./NotificationDropdown";

export const NotificationBell = () => {
  const { t } = useTranslation();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { data } = useListMyNotificationsQuery({ unseen: true });
  const count = data?.notifications.length ?? 0;

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end" isLazy>
      <PopoverTrigger>
        <Box position="relative" display="inline-flex">
          <IconButton aria-label={t("Alerts")} icon={<FiBell />} variant="ghost" size="md" onClick={onToggle} />
          {count > 0 && (
            <Box position="absolute" top="0" right="0" minW="18px" h="18px" px="1" rounded="full" bg="smError" color="white" fontSize="2xs" fontWeight="bold" display="flex" alignItems="center" justifyContent="center" border="2px solid" borderColor="smBackground">
              {count > 9 ? "9+" : count}
            </Box>
          )}
        </Box>
      </PopoverTrigger>
      <PopoverContent w="auto" bg="smBackground" borderColor="smBorder" shadow="xl" _focus={{ outline: "none" }}>
        <PopoverBody p="0">
          <NotificationDropdown onClose={onClose} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
